import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const LanguagesRoutes: Routes = [
  {
    path: "languages",
    loadComponent: () =>
      import("./languages/languages.component").then(
        (m) => m.LanguagesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./languages-list/languages-list.component").then(
            (m) => m.LanguagesListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./languages-form/languages-form.component").then(
            (m) => m.LanguagesFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./languages-form/languages-form.component").then(
            (m) => m.LanguagesFormComponent,
          ),
      },
    ],
  },
];
